/**
 * «Юниверситет» (28.09): тосты «+120 XP · …» и «Ачивка: …» — по одному, 2,6 с, поверх
 * шторки (портал в body, слой --z-toast). Ачивки приходят с задержкой 900 мс (макет),
 * чтобы не слипаться с тостом опыта.
 */
import { useCallback, useEffect, useRef, useState, type ReactNode } from "react";
import { createPortal } from "react-dom";
import css from "./uni.module.css";

const SHOW_MS = 2600;

export function useToasts(): { push: (msg: string, delayMs?: number) => void; node: ReactNode } {
  const [queue, setQueue] = useState<{ id: number; msg: string }[]>([]);
  const seq = useRef(0);
  const timers = useRef<number[]>([]);

  const push = useCallback((msg: string, delayMs = 0) => {
    const add = () => {
      const id = ++seq.current;
      setQueue((q) => [...q, { id, msg }]);
    };
    if (delayMs > 0) timers.current.push(window.setTimeout(add, delayMs));
    else add();
  }, []);

  const head = queue[0];
  const headId = head?.id;
  useEffect(() => {
    if (headId === undefined) return;
    const t = window.setTimeout(() => setQueue((q) => q.slice(1)), SHOW_MS);
    return () => window.clearTimeout(t);
  }, [headId]);

  useEffect(() => {
    const list = timers.current;
    return () => list.forEach((t) => window.clearTimeout(t));
  }, []);

  const node = createPortal(
    <div className={css.toastHost} role="status" aria-live="polite">
      {head ? <div key={head.id} className={css.toast}>{head.msg}</div> : null}
    </div>,
    document.body,
  );
  return { push, node };
}
